import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  computed,
  contentChild,
  input,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

@Directive({
  selector: '[dashboardCardHeaderActions]',
})
export class DashboardCardHeaderActionsDirective {}

@Directive({
  selector: '[dashboardCardFooter]',
})
export class DashboardCardFooterDirective {}

@Component({
  selector: 'ct-lib-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent],
  host: {
    class: 'ct-card',
    '[class.scrollable]': 'scrollable()',
  },
})
export class DashboardCardComponent {
  readonly title = input.required<string>();
  readonly icon = input<IconProp | null>(null);
  readonly scrollable = input(false);

  private readonly headerActionsSlot = contentChild(
    DashboardCardHeaderActionsDirective
  );
  private readonly footerSlot = contentChild(DashboardCardFooterDirective);

  readonly hasHeaderActions = computed(() => !!this.headerActionsSlot());
  readonly hasFooter = computed(() => !!this.footerSlot());
}
